/**
 * Browser Fingerprinting
 * Collects basic browser information for analytics
 */

/**
 * Get browser fingerprint data
 */
export function getBrowserFingerprint() {
  const userAgent = navigator.userAgent;

  // Parse browser info from user agent
  const browserInfo = parseBrowserInfo(userAgent);
  const screenBucket = getScreenBucket(window.screen.width, window.screen.height);
  const viewportBucket = getScreenBucket(window.innerWidth, window.innerHeight);

  return {
    version_tag: 'passive-v1',
    browser: browserInfo.browser,
    version: browserInfo.version,
    os: browserInfo.os,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    screen_bucket: screenBucket,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    viewport_bucket: viewportBucket,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language || navigator.userLanguage,
    languages: Array.isArray(navigator.languages) ? navigator.languages.slice(0, 5) : undefined,
    platform: navigator.platform,
    touch_support: 'ontouchstart' in window || navigator.maxTouchPoints > 0
  };
}

function getScreenBucket(width, height) {
  const normalizedWidth = Number.isFinite(Number(width)) ? Math.floor(Number(width) / 200) * 200 : null;
  const normalizedHeight = Number.isFinite(Number(height)) ? Math.floor(Number(height) / 200) * 200 : null;
  return normalizedWidth && normalizedHeight ? `${normalizedWidth}x${normalizedHeight}` : null;
}

/**
 * Parse browser information from user agent
 */
function parseBrowserInfo(userAgent) {
  let browser = 'Unknown';
  let version = 'Unknown';
  let os = 'Unknown';

  // Detect browser
  if (userAgent.indexOf('Firefox') > -1) {
    browser = 'Firefox';
    version = userAgent.match(/Firefox\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.indexOf('Edg') > -1) {
    browser = 'Edge';
    version = userAgent.match(/Edg\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.indexOf('Chrome') > -1) {
    browser = 'Chrome';
    version = userAgent.match(/Chrome\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.indexOf('Safari') > -1) {
    browser = 'Safari';
    version = userAgent.match(/Version\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) {
    browser = 'Internet Explorer';
    version = userAgent.match(/(?:MSIE |rv:)(\d+\.\d+)/)?.[1] || 'Unknown';
  }

  // Detect OS
  if (userAgent.indexOf('Win') > -1) {
    os = 'Windows';
  } else if (userAgent.indexOf('Mac') > -1) {
    os = 'macOS';
  } else if (userAgent.indexOf('Linux') > -1) {
    os = 'Linux';
  } else if (userAgent.indexOf('Android') > -1) {
    os = 'Android';
  } else if (userAgent.indexOf('iOS') > -1 || userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1) {
    os = 'iOS';
  }

  return { browser, version, os };
}

/**
 * Get UTM parameters from current URL
 */
export function getUTMParams() {
  const params = new URLSearchParams(window.location.search);
  const utmParams = {};

  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
    if (params.has(param)) {
      utmParams[param] = params.get(param);
    }
  });

  return Object.keys(utmParams).length > 0 ? utmParams : null;
}
